import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const getGroup = async (id: number) => {
  const response = await axios.get(`${getAPIService}/groups/${id}`)
  return response.data
}
